import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const Container = styled.div`
    width: 694px;
    max-width: 95%;
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 47, 67, 0.12);
    border-radius: 4px;
    padding: 24px;
    font-family: "Roboto", sans-serif;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Header = styled.div`
    font-size: 16px;
    color: #333333;
    font-weight: 700;
`;

export const InstructionsBox = styled.div`
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    padding: 16px;
`;

export const WarningBox = styled.div`
    border-radius: 4px;
    padding: 16px;
    border: 1px solid #c87239;
    background: #fcf6f3;
`;

export const InstructionsTitle = styled.h3`
    margin: 12px 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #333333;
`;

export const InstructionText = styled.p`
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    margin: 8px 0;
`;

export const MachineCodeSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const MachineCodeLabel = styled.label`
    font-size: 14px;
    color: #333333;
`;

export const MachineCodeInput = styled.input<{ $hasError?: boolean }>`
    padding: 10px;
    border: 1px solid ${({ $hasError }) => ($hasError ? "#d32f2f" : "#d6d6d6")};
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    outline: none;
    transition: border 0.2s ease;

    &:focus {
        border-color: ${({ $hasError }) => ($hasError ? "#d32f2f" : "#700ac1")};
    }

    &:disabled {
        background: #f5f5f5;
        color: #5c5c5c;
    }
`;

export const ErrorText = styled.div`
    font-size: 12px;
    color: #d32f2f;
`;

/* ===== Button with Transient Prop ===== */

interface ButtonProps {
    $variant?: "primary" | "secondary";
}

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
`;

export const Button = styled.button<ButtonProps>`
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1.25px;
    cursor: pointer;
    text-transform: capitalize;
    transition: 0.2s ease;

    ${({ $variant }) =>
        $variant === "primary"
            ? `
        background: #700AC1;
        color: #ffffff;
        border: none;

        &:hover {
          opacity: 0.9;
        }

        &:disabled {
          background: #c4a3e6;
          cursor: not-allowed;
          opacity: 0.7;
        }
      `
            : `
        background: #ffffff;
        color: #700AC1;
        border: 1px solid #700AC1;

        &:hover {
          background: #f7f0fc;
        }
      `}
`;

export const BulletIcon = styled.img`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 5px;
`;
export const InfoIcon = styled.img`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;
export const InstructionRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;
